





































































































































































































































































































import {
  computed,
  defineComponent,
  ref,
  watch,
} from '@nuxtjs/composition-api';

import {
  SfButton,
  SfCheckbox,
  SfHeading,
  SfLoader,
} from '@storefront-ui/vue';
import { storeToRefs } from 'pinia';
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import { digits, min, required } from 'vee-validate/dist/rules';
import JetInput from '~/components/JetUi/atoms/Input/JetInput.vue';
import JetUiButton from '~/components/JetUi/atoms/JetUiButton/JetUiButton.vue';
import Tooltip from '~/components/JetUi/atoms/Tooltip/Tooltip.vue';
import Warning from '~/components/JetUi/atoms/Warning/Warning.vue';
import SkeletonLoader from '~/components/SkeletonLoader/index.vue';
import { mergeItem } from '~/helpers/asyncLocalStorage';
import UserAddresses from '~/modules/checkout/components/UserAddresses.vue';
import { useCheckout, useCheckoutStore } from '~/stores/checkout';
import Billing from './Billing.vue';

extend('required', {
  ...required,
  message: 'This field is required',
});
extend('min', {
  ...min,
  message: 'The field should have at least {length} characters',
});
extend('digits', {
  ...digits,
  message: 'Please provide a valid phone number',
});

export default defineComponent({
  name: 'ShippingStep',
  components: {
    SkeletonLoader,
    SfHeading,
    SfButton,
    JetUiButton,
    JetInput,
    ValidationProvider,
    Warning,
    ValidationObserver,
    SfLoader,
    SfCheckbox,
    Billing,
    UserAddresses: () => import('~/modules/checkout/components/UserAddresses.vue'),
    VsfShippingProvider: () => import('~/modules/checkout/components/VsfShippingProvider.vue'),
    Tooltip,
  },
  setup() {
    const {
      saveShipping,
      fetchAddressByZipCode,
      changeCountry,
      changeAddressForm: changeShippingDetails,
      currentAddressId,
      addressForm: shippingDetails,
      loaded,
      hasSavedAddress: hasSavedShippingAddress,
      isAddNewAddressFormVisible,
      countries,
      countriesList,
      regionInformation,
      handleAddNewAddressBtnClick,
      handleSetCurrentAddress,
      isAuthenticated,
      zipCodeError,
      addresses,
      saveNewAddress,
      shippingMethods,
      cancelAddNewAddress,
      loadShippingCheckout,
    } = useCheckout('shipping');
    const checkoutStore = useCheckoutStore();
    const {
      loading, diffFromShipping, selectedShippingMethod, loadShippingMounted,
    } = storeToRefs(checkoutStore);

    const isSetAsDefaultRequested = ref(false);

    const shippingMethodLoading = ref(false);

    watch(currentAddressId, async (newAddressId) => {
      if (newAddressId) {
        shippingMethodLoading.value = true;
        const shippingDetailsData = {
          ...shippingDetails.value,
          customerAddressId: newAddressId,
          save_in_address_book: false,
        };

        await mergeItem('checkout', { shipping: shippingDetailsData });
        const shippingInfo = await saveShipping({ shippingDetails: shippingDetailsData });
        if (shippingMethods.value.length > 0 && shippingMethods.value !== shippingInfo?.available_shipping_methods) {
          selectedShippingMethod.value = null;
        }

        shippingMethods.value = shippingInfo?.available_shipping_methods ?? [];
        shippingMethodLoading.value = false;
      }
    });

    watch(loadShippingMounted, async (newLoadShippingMounted) => {
      if (newLoadShippingMounted) {
        await loadShippingCheckout();
      }
    });

    return {
      loaded,
      isAddNewAddressFormVisible,
      changeCountry,
      changeShippingDetails,
      countries,
      countriesList,
      currentAddressId,
      handleAddNewAddressBtnClick,
      handleSetCurrentAddress,
      hasSavedShippingAddress,
      isAuthenticated,
      shippingMethodLoading: computed(() => shippingMethodLoading.value),
      regionInformation,
      isSetAsDefaultRequested,
      zipCodeError,
      fetchAddressByZipCode,
      shippingDetails,
      shippingMethods,
      addresses: computed(() => addresses.value),
      saveNewAddress,
      loading,
      diffFromShipping,
      cancelAddNewAddress,
    };
  },
});
